import { getEnv } from '@ctct/ctct-helpers';

import { BaseApiClient } from '../BaseApiClient';

class SettingsSvcApi {
  private baseApiClient: BaseApiClient;

  constructor() {
    const baseUrl = `https://app${getEnv()}constantcontact.com/v1/settings`;

    this.baseApiClient = new BaseApiClient(baseUrl);
  }

  public getFeatureSetting(settingName: string, applicationId = 'myaccount') {
    return this.baseApiClient.get<unknown>(`/applications/${applicationId}/accounts/features/${settingName}`);
  }

  public getAccountSetting(settingName: string, applicationId = 'myaccount') {
    return this.baseApiClient.get<unknown>(`/applications/${applicationId}/accounts/settings/${settingName}`);
  }

  public putSetAccountSetting(settingName: string, settingValue: string, applicationId = 'myaccount') {
    return this.baseApiClient.put<unknown, string>(
      `/applications/${applicationId}/accounts/settings/${settingName}`,
      settingValue
    );
  }
}

export const settingsSvcApi = new SettingsSvcApi();
